import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{ resizable?: boolean }>()
  .create(({ theme, resizable }) => ({
    keyValueResponsive: {
      overflow: 'auto',
      padding: '0.5rem 0',
      width: '100%',
      '@container keyValue-container (min-width: 500px)': {
        width: '50%'
      },
      '@container keyValue-container (min-width: 1000px)': {
        width: '33.33%'
      },
      '@container keyValue-container (min-width: 1300px)': {
        width: '25%'
      }
    },
    keyValueResponsiveContainer: {
      containerName: 'keyValue-container',
      containerType: 'inline-size',
      display: 'flex',
      flexWrap: 'wrap',
      overflow: 'auto',
      resize: resizable ? 'horizontal' : 'none',
      width: '100%'
    },
    keyValueResponsiveLabel: {
      color: theme.vars.palette.text.secondary,
      fontSize: '0.75rem',
      width: '100%'
    },
    keyValueResponsiveValue: {
      fontWeight: 600,
      width: '100%',
      wordBreak: 'break-word'
    }
  }));

export default useStyles;
